import React from 'react';
const ReactNativeShare = ({ children }: any) => <>{children}</>;

export default ReactNativeShare;
